"use strict";
import { gsap } from "gsap";
import * as lock from "./_scrollLock";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation } from "swiper";
import SimpleBar from "simplebar";
gsap.registerPlugin(ScrollTrigger);
var $ = require("jQuery");
/**
 * DOMContentLoaded
 */
document.addEventListener(
  "DOMContentLoaded",
  () => {
    document.querySelector("body").classList.add("loaded");
  },
  false
);

// Anime - common
const anim = document.querySelectorAll(".anim");
anim.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("exit");
    },
  });
});
// Anime - fadein
const fadein = document.querySelectorAll(".fadein");
fadein.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("on");
    },
  });
});

// fixed scroll motif - 消す用
ScrollTrigger.create({
  trigger: ".footer",
  start: "top bottom",
  toggleClass: { targets: ".fixed-scroll", className: "fadeout" },
});

// modal
let swiperOption = {
  loop: true,
  allowTouchMove: false,
  modules: [Navigation],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
};
let faqSwiper = new Swiper(".swiper-main-faq", swiperOption);

let modalFaqButton = document.querySelectorAll(".modal__item");
for (let i = 0; i < modalFaqButton.length; i++) {
  modalFaqButton[i].addEventListener(
    "click",
    () => {
      showModal(i);
    },
    false
  );
}

function showModal(num) {
  document.querySelector(".modal").classList.add("active");
  faqSwiper.slideToLoop(num);
  lock.scrollLock();
}

// modal close button
let modalClose = document.querySelectorAll(".modal-close");
modalClose.forEach((target) => {
  target.addEventListener(
    "click",
    (e) => {
      document.querySelector(".modal.active").classList.remove("active");
      lock.scrollLock();
    },
    false
  );
});

let modalBlank = document.querySelectorAll(".modal__blank");
modalBlank.forEach((target) => {
  target.addEventListener(
    "click",
    (e) => {
      let current = e.currentTarget;
      let parent = current.closest(".modal");
      if (parent.classList.contains("active")) {
        parent.querySelector(".modal-close").click();
      }
    },
    false
  );
});

// horizone scroll
const scrollArea = document.querySelectorAll(".js-scroll-alert");
// 検知
function createEventScrollX(ele) {
  this._past_scroll_left = 0;
  this.ev_scroll_x = new CustomEvent("scroll-x", {
    bubbles: true,
    cancelable: true,
  });
  this.dispatch_callback = function (ev) {
    var cuT = ev.currentTarget;
    var now_l = cuT.scrollLeft;
    if (now_l !== this.past_scroll_left) {
      ele.dispatchEvent(this.ev_scroll_x);
      this.past_scroll_left = now_l;
    }
  };

  var events = ["scroll", "touchmove"];
  events.forEach(
    function (ev, idx, arr) {
      ele.addEventListener(ev, this.dispatch_callback.bind(this), {
        capture: true,
        passive: true,
      });
    }.bind(this)
  );
}

for (let i = 0; i < scrollArea.length; i++) {
  var evX = new createEventScrollX(scrollArea[i]);
  scrollArea[i].addEventListener(
    "scroll-x",
    function (ev) {
      let target =
        ev.currentTarget.getElementsByClassName("js-touch-scroll")[0];
      target.classList.add("is-hidden");
    },
    { capture: true, passive: true }
  );
}

let modalMotif = document.querySelectorAll(".modal__blc");

modalMotif.forEach((item, index) => {
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont01",
    // アニメーション開始のトリガー
    trigger: "#modalCont01 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",

    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });

  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont02",
    // アニメーション開始のトリガー
    trigger: "#modalCont02 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",

    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });

  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont03",
    // アニメーション開始のトリガー
    trigger: "#modalCont03 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont04",
    // アニメーション開始のトリガー
    trigger: "#modalCont04 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",

    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont05",
    // アニメーション開始のトリガー
    trigger: "#modalCont05 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont06",
    // アニメーション開始のトリガー
    trigger: "#modalCont06 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont07",
    // アニメーション開始のトリガー
    trigger: "#modalCont07 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont08",
    // アニメーション開始のトリガー
    trigger: "#modalCont08 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont09",
    // アニメーション開始のトリガー
    trigger: "#modalCont09 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
  ScrollTrigger.create({
    // スクロールトリガーの有効範囲の指定
    scroller: "#modalCont10",
    // アニメーション開始のトリガー
    trigger: "#modalCont10 .scroller-end",
    // アニメーションの開始位置
    start: "top bottom",
    // クラス追加削除などの処理
    toggleClass: {
      targets: ".fixed-scroll--modal",
      className: "fadeout",
    },
  });
});
